import { Component, OnInit } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { AppointmentCalendarHoliday } from './../../models/calendar/calendar.model';

import * as moment from 'moment';

@Component({
  selector: 'swb-appointment-holidays-list',
  templateUrl: './appointment-holidays-list.component.html'
})
export class AppointmentHolidaysListComponent extends ListBase<AppointmentCalendarHoliday> implements OnInit {

  public url = 'appointment-calendar-holidays';
  public urlPrefix = 'holidays';
  public routePrefix = 'holidays';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }

  public dateFormat(date: string): string{
    return moment.utc(date).format('DD.MM.Y');
  }
}
